<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <util-keys @keyup.ctrl.shift.48="shortcutFill(true)" />
        <util-keys @keyup.ctrl.shift.57="shortcutFill(false)" />
        <el-form
          :model="form"
          :rules="newRules"
          ref="ruleForm"
          class="flex flex-row w-full"
          autocomplete="off"
        >
          <div class="flex-1">
            <div class="lg:mb-4">
            </div>
           
            <!-- <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4">{{$t('presentations.type')}}</h2> -->
            <div class="flex -mx-2 flex-col lg:flex-row">
              
              <div class="px-2 w-full mb-2 lg:mb-0">
                <AccessibleElSelect
                  v-model="form.PresentarRecurso"
                  prop="PresentarRecurso"
                  :options="valuesForAccessibleSelect"
                  :withFormItem="true"
                  id-prefix="newpresentation"
                >
                  <template slot="label"><base-obligatory-icon/>{{$t('presentations.PresentarRecurso')}}</template>
                </AccessibleElSelect>
              </div>

              <div class="px-2 w-full mb-2 lg:mb-0">
                <AccessibleElSelect
                  v-model="form.Tramite"
                  prop="Tramite"
                  :options="listaTramitesFinalForAccessibleSelect"
                  :withFormItem="true"
                  :isDisabled="isLoadingInitial"
                  id-prefix="newpresentation"
                >
                  <template slot="label"><base-obligatory-icon/>{{$t('presentations.Tramite')}}</template>
                </AccessibleElSelect>
              </div>

            </div>

            <div class="lg:mb-2">
              <AccessibleElSelect
                v-model="form.DocsMix"
                prop="DocsMix"
                :options="listaDocumentosGroupingForAccessibleSelect"
                :withFormItem="true"
                :group="true"
                :isMultiple="true"
                :isDisabled="isLoadingInitial || !listaDocumentosGrouping || listaDocumentosGrouping.length === 0 || !form.Tramite"
                id-prefix="newpresentation"
              >
                <template slot="label">{{$t('presentations.docs_mix')}}</template>
              </AccessibleElSelect>
            </div>


            <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 ">{{$t('presentations.aditional_data')}}</h2>
            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('presentations.Asunto')}}
                  <el-form-item prop="Asunto">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.Asunto"
                      maxlength='240'
                    />
                  </el-form-item>
                </label>
              </div>
            </div>

            <div class="flex -mx-2 flex-col lg:flex-row">
              
              <div class="px-2 w-full mb-2 lg:mb-0">
                <div class="mandatory">
                  
                <div class="flex items-center mb-1">
                  <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon/>{{$t('presentations.Telefono')}}</label>
                  <base-tooltip-icon size="sm" :content="telefonoTooltip" class="ml-2"/>
                </div>
                  <el-form-item prop="Telefono">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.Telefono"
                      maxlength='20'
                    />
                  </el-form-item>
                </div>
              </div>

              <div class="px-2 w-full mb-2 lg:mb-0">
                <div class="mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1 mt-1">{{$t('presentations.Email')}}
                    <el-form-item prop="Email" >
                      <el-input
                        clearable
                        class="w-full"
                        v-model="form.Email"
                        maxlength='100'
                        autocomplete="email"
                      />
                    </el-form-item>
                  </label>
                </div>
              </div>
            </div>

            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('presentations.Observaciones')}}
                  <el-form-item prop="Observaciones">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.Observaciones"
                      maxlength='250'
                    />
                  </el-form-item>
                </label>
              </div>
            </div>

            
            <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 ">{{$t('presentations.certificate')}}</h2>
            <div class="lg:mb-2">
              <AccessibleElSelect
                v-model="form.Certificado"
                prop="Certificado"
                :options="certificadosForAccessibleSelect"
                :withFormItem="true"
                :isDisabled="isLoadingInitial"
                id-prefix="newpresentation"
              >
                <template slot="label"><base-obligatory-icon/>{{$t('app.available_certificates')}}</template>
              </AccessibleElSelect>
            </div>

          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive
            mode="secondary"
            :text="$t('app.cancel')"
            icon="cross"
            @click="goBack"
            :loading="isGeneralLoading"
          />
          <base-button-responsive
            mode="primary"
            :text="$t('presentations.send')"
            icon="save"
            @click="submitForm('ruleForm')"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
    </template>
  </detail-layout>
</template>

<script>
import { email as emailRegex } from '@/utils/regex'
import { i18n } from '@/i18n'
import DetailLayout from '@/components/layout/DetailLayout.vue'

import { newPresentacion } from '@/services/app/newPresentacion'
import { getTramitesSimple } from '@/services/notifications/getTramitesSimple' 
import { getNotification } from '@/services/notifications/getNotification'
import { getCertificatesPresentationSimple } from '@/services/certificates/getCertificatesPresentationSimple' 
import { getDocumentosSimple } from '@/services/certificates/getDocumentosSimple' 

import UtilKeys from '@/components/utilities/UtilKeys'
// import { v4 as uuidv4 } from 'uuid'

import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default {
  /* eslint-disable camelcase */
  name: 'new-presentation',
  components: {
    DetailLayout,
    UtilKeys,
    AccessibleElSelect
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      contenTooltipExample: 'Example.',
      isLoadingInitial: false,
      activeName: 'es',
      header: {
        title: 'NUEVA PRESENTACIÓN',
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'notification/presentations'
      },
      telefonoTooltip: i18n.t('tooltip.presentations.telefono'),
      form: this.getDefaultForm(),
      maxFiles: 99,
      listaTramitesPresentarRecursoSi: [],
      listaTramitesPresentarRecursoNo: [],
      listaDocumentos: [],
      listCerts: [],
      Asunto: '',
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      newRules: {
        PresentarRecurso: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        Tramite: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        DocsMix: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        Asunto: [
          {
            required: false,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        Telefono: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        Email: [
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        Observaciones: [
          {
            required: false,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        Certificado: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        fileMain: [
          {
            required: true,
            message: this.$i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.fileNameMain) {
                this.doAriaLiveAndReturnCallback(i18n.t('app.fill_data'), callback)
              } else {
                callback()
              }
            }
          },
          {
            required: true,
            message: this.$i18n.t('validation.not_pdf'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.fileNameMain || this.fileNameMain.length < 5 || this.fileNameMain.substr(this.fileNameMain.length - 4).toUpperCase() !== '.PDF') {
                this.doAriaLiveAndReturnCallback(i18n.t('validation.not_pdf'), callback)
              } else {
                callback()
              }
            }
          },
          {
            required: true,
            message: this.$i18n.t('validation.exceed_size_files') + ' (5 MB)',
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.fileNameMain && this.fileMain.filter(x => x.size > this.maxSizeFile).length > 0) {
                this.doAriaLiveAndReturnCallback(i18n.t('validation.not_pdf'), callback)
              } else {
                callback()
              }
            }
          }
        ],
        file: [
          {
            required: true,
            message: this.$i18n.t('validation.exceed_size_files') + ' (5 MB)',
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.fileName && this.file.filter(x => x.size > this.maxSizeFile).length > 0) {
                this.doAriaLiveAndReturnCallback(i18n.t('validation.not_pdf'), callback)
              } else {
                callback()
              }
            }
          },
          {
            required: true,
            message: this.extensionRuleMessage,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              let invalidExtension = false
              this.file.forEach(archivo => {
                if (!this.extensionesAdjuntosPermitidas.includes(this.getExtensionFromFileName(archivo.name).toUpperCase())) {
                  invalidExtension = true
                }
              })
              if (invalidExtension) {
                this.doAriaLiveAndReturnCallback(this.extensionRuleMessage, callback)
              } else {
                callback()
              }
            }
          },
        ]
      },
    }
  },
  computed: {
    isEmptyList: function () {
      return this.listaDocumentos === undefined || this.listaDocumentos === null || this.listaDocumentos.length === 0
    },
    listaDocumentosGrouping () {
      if (this.isEmptyList || !this.form.Tramite) return []
      const options = [
        {
          label: 'Documentos relacionados',
          options: [],
        },
        {
          label: 'Documentos de maestro',
          options: [],
        }
      ]
      this.listaDocumentos.forEach(x => {
        const doc = { value: x.idAdjunto, label: this.truncate(x.Nombre, 50, false) + '.' + x.Extension + ' ('+ this.truncate(x.CodigoTipoDocumento + ' - ' + x.DescripcionTipoDocumento, 50, false) +')' }
        if (x.EsMaestro) {
          options[1].options.push(doc)
        } else {
          options[0].options.push(doc)
        }
      })
      return options
    },
    listaTramitesFinal () {
      if (this.form.PresentarRecurso) return this.listaTramitesPresentarRecursoSi
      return this.listaTramitesPresentarRecursoNo
    },
    extensionRuleMessage: function () {
      return i18n.t('validation.not_extension') + this.extensionesAdjuntosPermitidas.join(', ')
    },
    extensionTooltipMessage: function () {
      return 'Número máximo de ficheros: ' + this.maxFiles + '. Tamaño máximo por fichero: ' + this.maxMB + 'MB. ' +
      i18n.t('validation.extension') + this.extensionesAdjuntosPermitidas.join(', ')
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    fileNameMain () {
      if (this.fileMain === null || this.fileMain.length === 0) {
        return ''
      } else if (this.fileMain.length === 1) {
        return this.fileMain[0].name
      } else {
        return '(' + this.fileMain.length + ') Archivos'
      }
    },
    fileName () {
      if (this.file === null || this.file.length === 0) {
        return ''
      } else if (this.file.length === 1) {
        return this.file[0].name
      } else {
        return '(' + this.file.length + ') Archivos'
      }
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    getIdEmpresaLogged: function () {
      return this.$store.getters['auth/user'].idEmpresa
    },
    valuesForAccessibleSelect () {
      return this.values.map(value => ({
        id: value.value,
        name: value.label,
        value: value.value
      }))
    },
    listaTramitesFinalForAccessibleSelect () {
      return this.listaTramitesFinal.map(value => ({
        id: value.Codigo,
        name: value.Descripcion,
        value: value.Codigo
      }))
    },
    listaDocumentosGroupingForAccessibleSelect () {
      return this.listaDocumentosGrouping.map(group => ({
        label: group.label,
        options: group.options.map(option => ({
          id: option.value,
          name: option.label,
          value: option.value
        }))
      }))
    },
    certificadosForAccessibleSelect () {
      return this.listCerts.map(item => ({
        id: item.key,
        name: item.Nombre,
        value: item.key
      }))
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    'form.PresentarRecurso': {
      deep: true,
      handler: 'watchPresentarRecursoHandler'
    },
    'form.Tramite': {
      deep: true,
      handler: 'watchTramiteHandler'
    },
  },
  created: async function () {
    this.isLoadingInitial = true

    const breadcrumbs = []
    breadcrumbs.push({
      path: 'notifications',
      name: this.$i18n.t('app.notifications')
    })
    if (this.$store.getters['app/fromRouteName'] !== null) {
      const breadcrumbHeader = this.$store.getters['app/headerBreadCrumb']
      breadcrumbs.push({ path: 'notification/details', name: this.truncate(breadcrumbHeader, 30, false) })
    } else {
      await this.downloadNotificationData(this.$route.params.id)
      breadcrumbs.push({ path: 'notification/details', name: this.truncate(this.Asunto, 30, false) })
      this.$store.commit('app/setheaderBreadCrumb', this.Asunto)
    }
    breadcrumbs.push({
      path: '',
      name: this.$i18n.t('app.new_presentation')
    })
    this.header.breadcrumb = breadcrumbs

    this.getCertificatesHandler()
    await this.downloadListaTramites()
    this.resetControlFormChanges()

    this.isLoadingInitial = false
  },
  mounted () {
    this.resetControlFormChanges()
  },
  methods: {
    isEmailValid: function (rule, value, callback) {
      if (!value) {
        callback() // queremos que la validación sea opcional en este caso.
      } else if (!emailRegex.test(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.email'), callback)
      } else {
        callback()
      }
    },
    getCertificatesHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idNEO: this.$route.params.id
        }
        const certs = await getCertificatesPresentationSimple(params)
        if (certs.blnError) {
          this.doFeedback(certs.msgError + ' [Código de error: ' + certs.codError + ']')
        }
        this.listCerts = certs.respuesta.map((x, index) => { return { ...x, key: index } })
        const certDefecto = this.listCerts.filter(x => x.PorDefecto)
        if (certDefecto && certDefecto.length === 1) {
          this.form.Certificado = certDefecto[0].key
        }
      } catch (error) {
        this.doFeedback(this.$i18n.t('feedback.error.general'))
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    getDocumentosSimpleHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idNEO: this.$route.params.id,
          codigoTramite: this.form.Tramite
        }
        const documentos = await getDocumentosSimple(params)
        if (documentos.blnError) {
          this.doFeedback(documentos.msgError + ' [Código de error: ' + documentos.codError + ']')
        }
        this.listaDocumentos = documentos.respuesta
      } catch (error) {
        this.doFeedback(this.$i18n.t('feedback.error.general'))
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    watchFormHandler () {
      this.$store.commit('app/setFormChanges', true)
    },
    shortcutFill (descargada = true) {
      this.doFeedback('Atajo detectado. Rellenando formulario con datos de prueba.', 'info')
      
    //   const guid = uuidv4()
    //   console.log('Guid generado', guid)
    //   this.form.TicketID = guid
    //   this.form.Asunto = guid
    //   if (descargada) this.form.Estado = 2
    //   else this.form.Estado = 0
    //   if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
    //     this.form.ClienteID = this.clientes[this.clientes.length - 1].IdEmpresa
    //   }
    //   this.organismos = [{
    //     id: 18585,
    //     label: 'AEAT',
    //     value: 'AEAT',
    //   }]
    //   setTimeout(() => {
    //     this.form.EmpresaID = this.companies[this.companies.length - 1].value
    //     setTimeout(() => {
    //       this.form.SedeID = 0
    //       this.form.FechaPublicacion = '2023-01-01 10:00:00'
    //       if (descargada) this.form.FechaDescarga = '2023-01-02 10:00:00'
    //       this.form.TipoNotificacion = 1
    //       this.form.OrganismoID = 18585
    //     }, 500)
    //   }, 500)
    },
    getExtensionFromFileName (fileName) {
      return fileName.split('.').at(-1)
    },
    resetForm () {
      this.$refs.ruleForm.resetFields()
    },
    handleOnExceedMain: function () {
      this.doFeedback('Se ha superado el número máximo de ficheros (' + 1 + ')', 'warning')
    },
    handleOnExceed: function () {
      this.doFeedback('Se ha superado el número máximo de ficheros (' + this.maxFiles + ')', 'warning')
    },
    handleChangeMain: function (file) {
      this.$refs.fileMainRef.clearValidate()
      this.fileMain.push(file)
    },
    handleChange: function (file) {
      this.$refs.fileRef.clearValidate()
      this.file.push(file)
    },
    handleRemoveMain: function (file) {
      this.fileMain = this.fileMain.filter(x => x.uid !== file.uid)
    },
    handleRemove: function (file) {
      this.file = this.file.filter(x => x.uid !== file.uid)
    },
    handlePreview: function () {
    },
    handleProgress: function (e) {
    },
    getDefaultForm: function () {
      return {
        PresentarRecurso: true,
        Tramite: null,
        Asunto: '',
        Telefono: '',
        Email: '',
        Observaciones: '',
        DocsMix: [],
        Certificado: null,
      }
    },
    watchPresentarRecursoHandler: async function () {
      this.form.Tramite = null
      this.doFeedback(this.$i18n.t('app.alert_form_changes'), 'info')
    },
    watchTramiteHandler: async function () {
      this.form.DocsMix = []
      if (this.form.Tramite) await this.getDocumentosSimpleHandler()
      this.doFeedback(this.$i18n.t('app.alert_form_changes'), 'info')
    },
    submitForm: function (formName) {
      this.newPresentationHandler(formName)
    },
    newPresentationHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        try {
          if (valid) {
            const objPresentacion = {
              idNEO: this.$route.params.id,
              PresentarRecurso: this.form.PresentarRecurso,
              CodigoTramite: this.form.Tramite,
              idAdjuntos: this.form.DocsMix,
              Asunto: this.form.Asunto,
              Telefono: this.form.Telefono,
              Email: this.form.Email,
              Observaciones: this.form.Observaciones,
              Certificado: this.listCerts.filter(x => x.key === this.form.Certificado)[0]
            }
            const responseNEO = await newPresentacion(objPresentacion)
            if (responseNEO.blnError === true) {
              this.doFeedback(responseNEO.msgError + ' [Código de error: ' + responseNEO.codError + ']')
            } else {
              this.resetControlFormChanges()
              setTimeout(() => {
                this.doFeedback('Solicitando presentación. Puede consultar el estado en esta vista.', 'info')
                this.goBack()
              }, 500)
            }
          } else {
            this.doFeedback('Error al procesar los datos, revise la información')
          }
        } catch (error) {
          console.error(error)
          this.doFeedback()
        } finally {
          this.$store.commit('setIsLoading', false)
        }
      })
    },
    goBack: function () {
      this.$router.push({ name: 'notification/presentations' })
    },
    downloadListaTramites: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idNEO: this.$route.params.id
        }
        const tramites = await getTramitesSimple(params)
        if (tramites.blnError) {
          this.doFeedback(tramites.msgError + ' [Código de error: ' + tramites.codError + ']')
        } else {
          this.listaTramitesPresentarRecursoSi = tramites.TramitesConPresentaRecurso
          this.listaTramitesPresentarRecursoNo = tramites.TramitesSinPresentaRecurso
        }
      } catch (error) {
        this.doFeedback(this.$i18n.t('feedback.error.general'))
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadNotificationData: async function (notificationId) {
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idNEO: notificationId
        }
        const notification = await getNotification(params)
        if (notification.blnError) {
          this.doFeedback(notification.msgError + ' [Código de error: ' + notification.codError + ']')
        }
        this.setNotification(notification.respuesta)
      } catch (error) {
        this.doFeedback(this.$i18n.t('feedback.error.general'))
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    setNotification: function (notification) {
      this.Asunto = notification.Asunto ? notification.Asunto : 'Sin asunto'
    },
  }
}
</script>
